// Gerado por scripts/build-icons.mjs — não editar manualmente.
import { createBankIcon } from "../createBankIcon";

/** Revolut */
export const Revolut = createBankIcon({
  name: "Revolut",
  slug: "revolut",
  compe: null,
  color: "#000000",
  viewBox: "0 0 100.03096 100.03096",
  html: "<rect\n     style=\"fill:#000000;fill-opacity:1\"\n     id=\"revolut_rect1\"\n     width=\"100.03096\"\n     height=\"100.03096\"\n     x=\"0\"\n     y=\"0\" />\n  <g transform=\"translate(21.0155,21.0155) scale(2.41667)\">\n    <path d=\"M 20.9133,6.9566 C 20.9133,3.1208 17.7898,0 13.9503,0 L 2.424,0 l 0,3.8605 l 10.9782,0 c 1.7376,0 3.177,1.3651 3.2087,3.043 c 0.016,0.84 -0.2994,1.633 -0.8878,2.2324 c -0.5886,0.5998 -1.375,0.9303 -2.2144,0.9303 L 9.2322,10.0662 a 0.2756,0.2756 0 0,0 -0.2755,0.2752 l 0,3.431 c 0,0.0585 0.018,0.1142 0.052,0.1612 L 16.2646,24 l 5.3114,0 l -7.2727,-10.094 c 3.6625,-0.1838 6.61,-3.2612 6.61,-6.9494 z M 6.8943,5.9229 L 2.424,5.9229 L 2.424,24 l 4.4704,0 z\" style=\"fill:#ffffff\" fill-rule=\"evenodd\" />\n  </g>",
});
